export default __webpack_public_path__ + "static/media/main_section15.f72805bc.jpg";